import { makeState, removeS, send_demand } from '../../api'
import { REMOVE_SERVICE, SERVICE_OFF, SERVICE_SEND } from '../constants'

export const updateState = (make, id) => async (dispatch) => {
  try {
    const data = await makeState(make, id)
    dispatch({
      type: SERVICE_OFF,
      payload: make,
    })
  } catch (error) {
    console.log(error.message)
  }
}

export const DemandService = (data) => async (dispatch) => {
  try {
    const response = await send_demand(data)
    dispatch({
      type: SERVICE_SEND,
      payload: response,
    })
  } catch (error) {
    console.log(error)
  }
}

export const removeService = (id) => async (dispatch) => {
  try {
    await removeS(id)
    dispatch({
      type: REMOVE_SERVICE,
      payload: id,
    })
  } catch (error) {
    console.log(error)
  }
}
